import mediaQueries from 'app/utils/mediaQueries';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import CrossSell from './crossSell';
import {
  adaptGrapheneProductToHybris,
  getYmalRecommendations,
} from '../../products/components/productList/advancedCommerce/getYmalRecommendations';

const {
  advancedCommerce: { productRecommendations },
} = window.inlineGlobalConfig;

const { categoryPathBasedOnClassification } = window.inlineProductDetails;

const CrossSellWrapper = ({ crossSellingComponents, productCode }) => {
  const [ymalComponent, setYmalComponent] = useState(null);

  useEffect(() => {
    if (!productRecommendations || !productCode) return;

    const fetchYmal = async () => {
      try {
        const response = await getYmalRecommendations(
          productCode,
          categoryPathBasedOnClassification?.[0]?.code || '$',
          window.location.href,
          'pdp_recs_1'
        );

        const productList = response?.elements?.pdp_recs_1?.products?.results || [];

        if (productList.length > 0) {
          const parts = new Intl.NumberFormat(response.header.language_culture, {
            style: 'currency',
            currency: response.header.currency,
          }).formatToParts(0);

          const currencySymbol = parts.find(part => part.type === 'currency').value;

          const adaptedProducts = productList.map(gProduct =>
            adaptGrapheneProductToHybris(gProduct.item, currencySymbol)
          );

          const newYmalComponent = {
            id: crossSellingComponents?.[0].id,
            title: crossSellingComponents?.[0].title,
            name: crossSellingComponents?.[0].name,
            products: adaptedProducts,
            displayProductTitles: true,
            displayProductPrices: true,
            maximumNumberProducts: 8,
          };

          setYmalComponent([newYmalComponent]);
        }
      } catch (error) {
        console.error('❌ YMAL FETCH ERROR:', error);
      }
    };

    fetchYmal();
  }, [crossSellingComponents, productCode]);

  const componentsToRender = productRecommendations ? ymalComponent || [] : crossSellingComponents;

  if (componentsToRender.length > 0) {
    return createPortal(
      componentsToRender
        .filter(component => component.products?.length)
        .map((component, index) => {
          const products = component.products?.filter((product, innerIndex) => {
            const DEFAULT_MAX_PRODUCTS = 8;
            const isMobile = mediaQueries.is_small_only();
            const maximumNumberProducts = component.maximumNumberProducts ?? DEFAULT_MAX_PRODUCTS;
            if (isMobile) {
              return innerIndex < 4;
            }
            return innerIndex < maximumNumberProducts;
          });
          return (
            <CrossSell
              key={`${component.id}_${index + 1}`}
              id={component.id.replace(/[^A-Za-z0-9]+/g, '')}
              products={products}
              title={component.title}
              name={component.name}
              displayProductTitles={component.displayProductTitles}
              displayProductPrices={component.displayProductPrices}
              productCode={productCode}
            />
          );
        }),
      document.getElementById('CrossSelling')
    );
  }

  return null;
};

const mapStateToProps = ({ detailsPage }) => ({
  productCode: detailsPage.loadedProduct.productCode,
  crossSellingComponents: detailsPage.loadedProduct.contentSlotsJson?.CrossSelling
    ? detailsPage.loadedProduct.contentSlotsJson.CrossSelling.components
    : [],
});

export default connect(mapStateToProps)(CrossSellWrapper);
